import React, { Component } from 'react';
import PropTypes from 'prop-types';
import jwt from 'jsonwebtoken';

import './Metabase.style.less';
class Metabase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      metabaseUrl: null,
    };
  }

  componentDidMount() {
    const { resource, resourceKey } = this.props;
    const METABASE_SITE_URL = process.env.METABASE_URL;
    const METABASE_SECRET_KEY = process.env.METABASE_TOKEN;
    const payload = {
      resource,
      params: {},
      exp: Math.round(Date.now() / 1000) + 10 * 60,
    };
    const token = jwt.sign(payload, METABASE_SECRET_KEY);

    const metabaseUrl = `${METABASE_SITE_URL}/embed/${resourceKey}/${token}#bordered=true&titled=true`;

    this.setState({ metabaseUrl });
  }

  render() {
    return (
      <iframe
        title="metabase"
        className="metabase-wrapper"
        frameBorder={0}
        src={this.state.metabaseUrl}
        {...this.props}
      />
    );
  }
}

Metabase.propTypes = {
  resourceKey: PropTypes.string,
  resource: PropTypes.object,
};

export default Metabase;
